import { baseApi } from "./apiConfig";

export const getUserRecentSearch = async (timestamp = new Date().getTime()) => {
  try {
    const response = await baseApi.post(`portal/userRecentSearch?${timestamp}`);
    const { status, data } = response;
    if (status === 200) {
      return data?.cookieElements || [];
    } else {
      throw response;
    }
  } catch (error) {
    console.error("Error in getUserRecentSearch", error);
  }
};
export const getUserSavedSearch = async ({
  emailId,
  pageNumber = 0,
  pageSize = "5",
}) => {
  try {
    const response = await baseApi.post("/portal/drawer/getUserSavedSearch", {
      emailId,
      pageNumber,
      pageSize,
    });
    const { status, data } = response;
    if (status === 200) {
      return data?.saveSearchResponseList || [];
    } else {
      throw response;
    }
  } catch (error) {
    console.error("Error in getUserSavedSearch", error);
  }
};
export const updateRecentSearch = async (searchBy, type, iD) => {
  try {
    const query = iD + "&type=" + type;
    const response = await baseApi.get(`/portal/getSearchUrl?id=${query}`);
    if (response?.status === 200) {
      const formData = new FormData();
      formData.append("searchBy", searchBy);
      formData.append("baseSearchUrl", "/" + response?.data?.url);
      formData.append("searchURI", "/" + response?.data?.searchURI);
      const responseSaveSearch = await baseApi.post(
        "/portal/saveRecentSearch",
        formData
      );
      const { status, data } = responseSaveSearch;
      if (status === 200) {
        return data;
      } else {
        throw responseSaveSearch;
      }
    } else {
      throw response;
    }
  } catch (error) {
    console.error("Error in getUserRecentSearch", error);
  }
};

export const getRecommandedProperty = async (searchText) => {
  try {
    const response = await baseApi.get(
      `portal/v2.0/recommendedProperties?searchText${
        searchText ? `=${searchText}` : ""
      }`
    );
    const { status, data } = response;
    if (status === 200) {
      return data?.recommendedPropertyList || [];
    } else {
      throw response;
    }
  } catch (error) {
    console.error("Error in getRecommandedProperty", error);
  }
};

export const getRecommendedPropertyWatchList = async (propertyIds) => {
  try {
    const response = await baseApi.post(`portal/getPropertyWatchStatus`, {
      propertyIds: propertyIds.join(","),
    });

    const { status, data } = response;
    if (status === 200) {
      return data?.propertyStatusList || [];
    } else {
      throw response;
    }
  } catch (error) {
    console.error("Error in getRecommandedProperty", error);
  }
};

export const getCheckoutOffers = async () => {
  try {
    const response = await baseApi.get(`/portal/v3.0/checkout-offers`);
    const { status, data } = response;
    if (status === 200) {
      return data?.campaignDisplayDTOs || [];
    } else {
      throw response;
    }
  } catch (error) {
    console.error("Error in getCheckoutOffers", error);
  }
};

//fetch home page CMS
export const getHomePageCMS = async (path) => {
  const response = await baseApi.get(
    encodeURI(`portal/get-new-cms-data/hubzuweb?template=/hubzuweb/${path}`)
  );
  if (response && response.status === 200) {
    return response.data;
  }
  return null;
};

// process visitor
export const processVisitor = async () => {
  const response = await baseApi.get(
    encodeURI(`portal/visitor/processVisitor`)
  );
  if (response && response.status === 200) {
    return response.data;
  }
  return null;
};

export const getCommercialProperties = async ()  => {
  try {
    const response = await baseApi.get('/portal/auctions?category=commercial&pageSize=15');
    const { status, data } = response;
    if (status === 200 && data?.data) {
      return data?.data?.srpTupples || [];
    } else {
      throw response;
    }
  } catch (error) {
    console.error("Error in getCommercialProperties", error);
  }
};

export const getSignatureHomes = async () => {
  try {
    const response = await baseApi.get('/portal/auctions?sid=signature-seller&pageSize=15');
    const { status, data } = response;
    if (status === 200 && data?.data) {
      return data?.data?.srpTupples || [];
    } else {
      throw response;
    }
  } catch (error) {
    console.error("Error in getSignatureHomes", error);
  }
};

export const getNewToHubzu = async () => {
  try {
    const response = await baseApi.get('/portal/auctions?newToHubzu=NEW_TO_HUBZU&pageSize=15');
    const { status, data } = response;
    if (status === 200 && data?.data) {
      return data?.data?.srpTupples || [];
    } else {
      throw response;
    }
  } catch (error) {
    console.error("Error in getNewToHubzu", error);
  }
};

export const getPropertiesNearYou = async ()  => {
  try {
    const response = await baseApi.get('/portal/near-me?sort=Distance&pageSize=15');
    const { status, data } = response;
    if (status === 200 && data?.data) {
      return data?.data?.srpTupples || [];
    } else {
      throw response;
    }
  } catch (error) {
    console.error("Error in getPropertiesNearYou", error);
  }
};

export const getSavedProperties = async (emailId, pageNumber = 0, pageSize = 10) => {
  try {
    const response = await baseApi.post('/portal/drawer/getUserSavedProperties', {
      emailId,
      pageNumber,
      pageSize,
    });
    const { status, data } = response;
    if (status === 200) {
      return data?.propertyWatchResponseList || [];
    } else {
      throw response;
    }
  } catch (error) {
    console.error("Error in getSavedProperties", error);
  }
};

export const getAlerts = async () => {
  try {
    const response = await baseApi.get('/portal/allAlerts');
    const { status, data } = response;
    if (status === 200) {
      // Filter out incomplete alert objects (empty objects from API)
      const alerts = data?.alerts || [];
      return alerts.filter(alert => alert && alert.message);
    } else {
      throw response;
    }
  } catch (error) {
    console.error("Error in getAlerts", error);
  }
};
